import { Dispatch, FunctionComponent, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";

import { Modal } from "@/components";

import { Checkbox } from "@/components/Checkbox/Checkbox";

import { useDeleteKpiDataMutation } from "../../redux/kpi/kpi.api";

interface KpiDataDeleteModal {
	isOpen: boolean;
	onClose: Dispatch<SetStateAction<boolean>>;
	/** The company whose KPI data to delete. Defaults to the caller's own company. */
	companyId?: number;
}

export const KpiDataDeleteModal: FunctionComponent<KpiDataDeleteModal> = ({
	isOpen,
	onClose,
	companyId,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`kpiDashboard.${key}`);

	const [deleteKpiData, { isLoading: isDeleting }] = useDeleteKpiDataMutation();

	const [isDeleteChecked, setIsDeleteChecked] = useState(false);

	const onSubmit = async () => {
		try {
			await deleteKpiData(companyId).unwrap();
			onClose(false);
		} catch (err) {
			console.error(err);
		}
	};

	return (
		<Modal
			disableSave={!isDeleteChecked}
			handleClose={() => {
				onClose(false);
			}}
			handleSave={() => {
				onSubmit();
			}}
			isLoading={isDeleting}
			isOpened={isOpen}
			submitButtonColor="error"
			submitButtonText={t("basics.delete")}
			title={ts("deleteKPITitle")}
		>
			<div className="flex flex-col gap-4">
				<p className="text-[16px]">{ts("deleteKPIWarning")}</p>
				<Checkbox
					isChecked={isDeleteChecked}
					labelClass="mt-0"
					onChange={() => setIsDeleteChecked(!isDeleteChecked)}
				>
					<p>{ts("deleteKPIConfirm")}</p>
				</Checkbox>
			</div>
		</Modal>
	);
};
